import { Component } from '@angular/core';
import { WidgetTextareaComponent } from '../widget-textarea/widget-textarea.component';

@Component({
  selector: 'app-widget-conditional-textarea',
  templateUrl: './widget-conditional-textarea.component.html',
  styleUrls: ['./widget-conditional-textarea.component.scss'],
})
export class WidgetConditionalTextareaComponent extends WidgetTextareaComponent {
  public updateValue(event: { target: { value: string } }) {
    if (this.boundControl) {
      this.formControl.setValue(event.target.value);
    } else {
      super.updateValue(event);
    }
  }
}
